import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {Loading} from '@components/ui/loading/loading';
import {StatusTag} from '@components/ui/status-tag/status-tag';
import {SyncedAnomalyDate} from '@app/pages/crop-monitoring/pages/anomalies/managers/anomaly-date-sync.manager';

@Component({
  selector: 'app-anomaly-date-indicator',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Loading, StatusTag],
  templateUrl: './anomaly-date-indicator.component.html',
})
export class AnomalyDateIndicatorComponent {
  readonly syncedAnomalyDate = input<SyncedAnomalyDate | null>(null);
  readonly syncing = input<boolean>(false);
}
